import {Component, EventEmitter, inject, Output} from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';
import {Clipboard} from '@angular/cdk/clipboard';
import {RecordDataValue} from '../../../../types/records-table.types';
import {smoothShowHideHeight} from '../../../../../shared/animations/smoothShowHideAnimations';
import {UtilityService} from '../../../../services/utility.service';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-text-record-table-item',
  standalone: false,
  templateUrl: './text-record-table-item.component.html',
  styleUrls: [
    './text-record-table-item.component.scss',
    '../base-record-table-item-styles.scss'
  ],
  animations: [smoothShowHideHeight]
})
export class TextRecordTableItemComponent extends BaseRecordTableItemComponent{
  @Output() inputValueChanged: EventEmitter<string> = new EventEmitter<string>();

  public isCustomTooltipShowed: boolean = false;

  private clipboard: Clipboard = inject(Clipboard);
  private utilityService: UtilityService = inject(UtilityService);

  get isUtmLink(): boolean {
    return this.columnParam?.columnProperties.LINK?.type === 'UTM';
  }

  public isLinkAvailable(): boolean {
    return !!this.columnParam.columnProperties.LINK?.type && !!this.value;
  }

  public handleInputValueChange(value: unknown): void {
    this.inputValueChanged.emit(value as string);
  }

  public handleCopyToClipboardButtonClick(value: RecordDataValue, tooltipRef: MatTooltip): void {
    this.copyToClipboard(value).then();
    this.showCopiedTooltip(tooltipRef, 1000);
  }

  public handleValueClick(value: RecordDataValue): void {
    if (!this.isLinkAvailable()) { return; }

    window.open(value as string, '_blank')?.focus();
  }

  public showCustomTooltip(): void {
    if (!this.isUtmLink) { return; }

    this.isCustomTooltipShowed = true;
  }

  public hideCustomTooltip(): void {
    this.isCustomTooltipShowed = false;
  }

  public prepareUtmTooltip(): Record<string, string> {
    if (!this.isUtmLink) { return {}; }

    return this.utilityService.getQueryParamsFromLink(this.value as string);
  }

  private async copyToClipboard(value: RecordDataValue): Promise<void> {
    this.clipboard.copy(value as string);
  }

  private showCopiedTooltip(tooltipRef: MatTooltip, delay: number): void {
    tooltipRef.show();
    setTimeout(() => { tooltipRef.hide(); }, delay);
  }
}
